import React from 'react';

import { ConfirmDialog } from '@gogame/components';
import { LegacyTextList } from '@gogame/components';
import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

import { removeCreatives } from 'scenes/Gallery/GalleryPage/Creatives/sources/creatives';

import { remove } from '../queryKeyFactory';

export const useBatchRemove = () => {
  const showModal = useScreenModalV2(ConfirmDialog);

  const mutation = useMutation(remove(), removeCreatives, {
    successMessage: (data, variables) => {
      const notRemoved = variables.ids.length - data;
      const notRemovedText = notRemoved
        ? `${notRemoved} ${
            notRemoved > 1
              ? "original creatives weren't"
              : "original creative wasn't"
          } removed`
        : '';
      return `${data} ${
        data > 1 ? 'creatives were' : 'creative was'
      } successfully removed. ${notRemovedText ? notRemovedText : ''}`;
    },
  });

  const handleAction = async (rows) => {
    const data = rows.map(({ id, name }) => ({ id, name }));
    const ids = data.map(({ id }) => id);
    await showModal({
      title: `Delete Creative(s)?`,
      confirmActionLabel: 'Delete',
      children: (
        <LegacyTextList
          data={data}
          limit={5}
          unitsName={'Creatives'}
          position={'top'}
        />
      ),
    });
    mutation.mutateAsync({ ids });
  };

  return [handleAction, mutation];
};
